import React, { useEffect } from "react";
import PropTypes from "prop-types";
import TitlePages from "../../../../layout/TitlePages";
import Breadcrumbs from "../../../../layout/Breadcrumbs";
import ConvenioCard from "../../../../components/common/ConvenioCard";

/**
 * Plantilla unificada para las páginas de Convenios por Año (/Convenios2014 ... /Convenios2026).
 * Asegura que todas las páginas compartan exactamente el mismo diseño, cuadrícula y componentes.
 * 
 * @param {number|string} year - Año de los convenios a mostrar.
 * @param {Array} data - Lista de objetos convenio [{ id, title, url, ... }].
 */
const ConveniosYearPage = ({ year, data = [] }) => {
  useEffect(() => {
    document.title = `Convenios ${year}`;
  }, [year]);

  return (
    <div className="margin-bottom-2">
      <Breadcrumbs
        path={[
          { label: "Transparencia", url: "/Transparencia" },
          { label: "Convenios", url: "/Convenios" },
          { label: `${year}` },
        ]}
      />

      <TitlePages title="Transparencia" subTitle={`Convenios ${year}`} />

      {/* Cuadrícula responsive de tarjetas de convenios: 4 en desktop, 3 en tablet, 2 en móvil */}
      <section
        className="w-100 convenios-year-grid"
        aria-label={`Listado de Convenios del año ${year}`}
      >
        {data.map((item, index) => (
          <ConvenioCard
            key={item.id || index}
            title={item.title}
            url={item.url}
            delayMs={index * 60}
          />
        ))}
      </section>
    </div>
  );
};

ConveniosYearPage.propTypes = {
  year: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default ConveniosYearPage;
